import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Button,
  Checkbox,
  Tag,
  Select,
  Space,
  Spin
} from "antd";
import { PageHeader } from '@ant-design/pro-components';

import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { ExpandAltOutlined, EditOutlined } from "@ant-design/icons";
import { AlignType } from 'rc-table/lib/interface';

import { apiCand } from "../../../../services/apiCand";
import { obterCaracteristicasConselheiro } from "../../../../services/apiAuxiliar";

import { maskCpf } from "../../../../utils/maskFunctions";

import { useNavigate } from "react-router-dom";
import { errorMessage, infoMessage } from "../../../../utils/messages";

import { ICaracteristicasMandato, IMandatoDirigenteConsulta } from "../../Componentes/InterfaceMandato";

import "../style.css";
import { onlyNumbers } from "../../../../utils/utilsFunctions";
import { IEntidade } from "../../../../Interfaces/DadosPrevicInterfaces";
import { getEntidadesDoUsuarioConsultar } from "../../../../auth/entidadeUsuario";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../parametrosUI";
import { salvarPesquisa, obterPesquisa, limparPesquisaSalva } from "../../../../utils/contextoPesquisa";
import { CategoriasDirigente } from "../../../../config/Contantes";

const { Option } = Select;

const Consultar: React.FC<any> = (props: any) => {
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [mandatoConselheiro, setMandatoConselheiro] = useState();
  const [mandatoConselheiros, setMandatoConselheiros] = useState<IMandatoDirigenteConsulta[]>([]);

  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const [manter, setManter] = useState(2); // ESTADOS PARA PASSAR PARA A TELA SEGUINTE - 2 : Detalhar / 3 : Alterar;

  const [caracteristicasMandato, setCaracteristicasMandato] = useState<ICaracteristicasMandato[]>([]);


  useEffect(() => {
    window.scrollTo(0, 0);

    const pesquisaSalva = obterPesquisa('mandatoconselheiro');
    if (pesquisaSalva){
      setMandatoConselheiros(pesquisaSalva.resultado);
      setTotalElements(pesquisaSalva.resultado.length);

      form.setFieldsValue({
        matriculaEfpc: pesquisaSalva.parametros.matriculaEfpc,
        nuCpf: maskCpf(pesquisaSalva.parametros.nuCpf),
        nmPessoaFisica: pesquisaSalva.parametros.nmPessoaFisica,
        idCaracteristica: pesquisaSalva.parametros.idCaracteristica,
        checkConsultaAtivo: pesquisaSalva.parametros.consultaAtivo,
        checkConsultaInativo: pesquisaSalva.parametros.consultaInativo,
        checkConsultaDeliberativo: pesquisaSalva.parametros.idCategoria === CategoriasDirigente["DELIBERATIVO"].value.toString(),
        checkConsultaFiscal: pesquisaSalva.parametros.idCategoria === CategoriasDirigente["FISCAL"].value.toString(),

        entidade: pesquisaSalva.nmTextos.entidade,
        nmCaracteristica: pesquisaSalva.nmTextos.nmCaracteristica,
      });
    }
    const entidadeUsuario = getEntidadesDoUsuarioConsultar();
    setEntidades(entidadeUsuario);
    if (entidadeUsuario.length === 1){
      form.setFieldsValue({
        entidade: entidadeUsuario[0].sigla,
        matriculaEfpc: entidadeUsuario[0].matricula,
      });
    }

    const loadAsync = async () => {
      let res = await obterCaracteristicasConselheiro();
      setCaracteristicasMandato(res.data);
    }
    loadAsync();
    
  }, []);

  useEffect(() => {
    if (mandatoConselheiro) pushToManter(mandatoConselheiro, manter);
  }, [mandatoConselheiro]);


  function pushToManter(manDir: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: manDir
    }
    navigate("/dirigente/conselheiro/manter", { state: tpSelecao });
  }

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      key: "SIGLA",
      width: 150,
      title: "Entidade",
      dataIndex: "sigla",
    });

    cols.push({
      key: "cpf",
      width: 150,
      title: "CPF",
      dataIndex: "",
      render: (mandir: IMandatoDirigenteConsulta) => (
        <Input
          value={maskCpf(mandir.nuCpf)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      key: "nome",
      // width: 400,
      title: "Nome Completo",
      dataIndex: "nmPessoaFisica",
    });

    cols.push({
      key: "csCategoria",
      width: 100,
      title: "Categoria",
      dataIndex: "categoria",
    });

    cols.push({
      key: "dtFimMandato",
      width: 100,
      title: "Data de término",
      dataIndex: "dtFimMandato",
    });

    cols.push({
      key: "csCondicaoMandato",
      width: 100,
      title: "Condição",
      dataIndex: "condicao",
    });

    cols.push({
      key: "situacao",
      width: 80,
      title: "Situação",
      dataIndex: "",
      render: (mandir: IMandatoDirigenteConsulta) => (
        <>
          <Tag color={mandir.situacaoVigencia ? "geekblue" : "volcano"} key={mandir.idMandato}>
            {mandir.situacaoVigencia && mandir.situacaoVigencia ? "ATIVO" : "INATIVO"}
          </Tag>
        </>
      ),
    });

    cols.push({
      key: "opcoes",
      width: 80,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (mandir: IMandatoDirigenteConsulta) => (
        <>
          <ExpandAltOutlined style={{ color: "blue" }}
            // shape="round"
            id='detalhar'
            onClick={() => {
              setManter(2);
              getMandatoDirigentePorId(mandir.idMandato);
            }}
          />

          {false && ( //As condições são mais complexas
            <EditOutlined style={{ color: "blue" }}
              id='alterar'
              onClick={() => {
                setManter(3);
                getMandatoDirigentePorId(mandir.idMandato);
              }} />
          )}
        </>
      ),
    });

    return cols;
  }

  const columns = gerarColunas();

  const handlerCheckConsultaAtivo = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkConsultaAtivo": e.target.checked,
    });
  };

  const handlerCheckConsultaInativo = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkConsultaInativo": e.target.checked,
    });

  };

  const handlerCheckConsultaDeliberativo = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkConsultaDeliberativo": e.target.checked,
    });
  };

  const handlerCheckConsultaFiscal = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkConsultaFiscal": e.target.checked,
    });

  };

  const [entidades, setEntidades] = useState<IEntidade[]>([]);

  const handlerEntidade = async (value: any) => {
    form.setFieldsValue({
      entidade: value.children,
      matriculaEfpc: value.key,
    });
  };

  const conselheiroNaoEncontrado = () => {
    infoMessage("O sistema não encontrou resultado para consulta realizada");
  };

  const obterParametrosDoForm = () => {
    let categoria = "";
    const deliberativo = form.getFieldValue("checkConsultaDeliberativo") || false;
    const fiscal = form.getFieldValue("checkConsultaFiscal") || false;
    if (deliberativo && !fiscal){
      categoria = CategoriasDirigente["DELIBERATIVO"].value.toString();
    }
    if (!deliberativo && fiscal){
      categoria = CategoriasDirigente["FISCAL"].value.toString();
    }

    return {
        page: form.getFieldValue("pagina") || 0,
        limit: form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE, //linhaPorPagina

        matriculaEfpc: onlyNumbers(form.getFieldValue("matriculaEfpc")) || "",
        nuCpf: onlyNumbers(form.getFieldValue("nuCpf")) || "",
        nmPessoaFisica: form.getFieldValue("nmPessoaFisica") || "",
        idCaracteristica: form.getFieldValue("idCaracteristica") || "",
        idCategoria: categoria,
        consultaAtivo: form.getFieldValue("checkConsultaAtivo") || "",
        consultaInativo: form.getFieldValue("checkConsultaInativo") || "",
    };
  }

  const getMandatoDirigente = async () => {
    try {
      setLoading(true);

      const params = obterParametrosDoForm();
      let lQuery = `mandatoconselheiro?${(new URLSearchParams(params)).toString()}`;

      const { data } = await apiCand.get(lQuery);
      setMandatoConselheiros(data.content);
      setTotalElements(data.totalElements);
      salvarEstado(params, data.content);

      if (data.content.length === 0) {
        conselheiroNaoEncontrado();
      }
    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };

  const getMandatoDirigentePorId = async (idMandato: number) => {
    try {
      setLoading(true);

      let lQuery = `mandatoconselheiro/${idMandato}`;
      const { data } = await apiCand.get(lQuery);
      setMandatoConselheiro(data);

    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };


  const [pageSize, setpageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  const handlePaginationChange = async (page: number, pagination?: number) => {
    if (pagination) {
      setpageSize(pagination);
    }
    form.setFieldsValue({
      pagina: page-1,
    });
    getMandatoDirigente();
  };

  const handleShowSizeChange = async (current: any, size: any) => {
    form.setFieldsValue({
      linhaPorPagina: size,
    });
    getMandatoDirigente();
  };

  function salvarEstado(parametros :any, dados :any[]) {
    const nmTextos = {
        entidade: form.getFieldValue("entidade") || "",
        nmCaracteristica: form.getFieldValue("nmCaracteristica") || "",
    };

    const pesq = {
      resultado: dados,
      parametros: parametros,
      nmTextos: nmTextos
    };
    salvarPesquisa('mandatoconselheiro', pesq);
  }

  function limparConsulta() {
    setMandatoConselheiros([]);
    setMandatoConselheiro(undefined);
    setTotalElements(0);
    limparPesquisaSalva();
    form.resetFields();
  }

  const maskFieldCpf = (isValue: string) => {
    if (form.getFieldValue("nuCpf")) {
      isValue = form.getFieldValue("nuCpf");
    }

    form?.setFieldsValue({
      nuCpf: maskCpf(isValue),
    });
  };

  return (
    <Spin spinning={loading} >

      <>
        <PageHeader
          className="site-page-header"
          title="Consultar Conselheiros"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>
          <Form layout="vertical" form={form} style={{ marginTop: "-100px" }}>
            <Form.Item name="pagina" />
            <Form.Item name="linhaPorPagina" />

            <Row>
              <Col xs={12} xl={12}>
                <Form.Item label="Entidade"
                  labelCol={{ span: 12 }}
                  name="entidade"
                  colon={false}
                >
                  <Select
                    showSearch
                    filterOption
                    optionFilterProp='children'
                    placeholder='Selecione a entidade'
                    disabled={entidades.length === 1}
                    onChange={(_, index) => {
                      handlerEntidade(index);
                    }}
                  >
                    {entidades?.map((e: IEntidade) => (
                      <Option key={e.matricula} value={e.matricula}>
                        {e.sigla}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} xl={12}>
                <Form.Item label="Característica"
                  labelCol={{ span: 12 }}
                  name="nmCaracteristica"
                  colon={false}
                >
                  <Select
                    showSearch
                    filterOption
                    allowClear
                    optionFilterProp='children'
                    placeholder='Característica'
                    onChange={(_, index) => {
                      const value:any = index;
                      if (value){
                        form.setFieldsValue({
                          "nmCaracteristica": value.children,
                          "idCaracteristica": value.key,
                        });
                      } else {
                        form.setFieldsValue({
                          "idCaracteristica": ''
                        });
                      }
                    }}
                  >
                      {caracteristicasMandato?.map((e: ICaracteristicasMandato) => (
                        <Option key={e.idCaracteristicaMandato} value={e.idCaracteristicaMandato}>
                          {e.nmCaracteristica}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} xl={12}>
                <Form.Item
                  label="Situação"
                  colon={false}
                >
                  <Space>
                    <Col>
                      <Form.Item
                        name="checkConsultaAtivo"
                        colon={false}
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handlerCheckConsultaAtivo}
                        >
                          Ativo
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        name="checkConsultaInativo"
                        colon={false}
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handlerCheckConsultaInativo}
                        >
                          Inativo
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Space>
                </Form.Item>
              </Col>
              <Col xs={12} xl={12}>
                <Form.Item
                  label="Órgão"
                  colon={false}
                >
                  <Space>
                    <Col>
                      <Form.Item
                        name="checkConsultaDeliberativo"
                        colon={false}
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handlerCheckConsultaDeliberativo}
                        >
                          {CategoriasDirigente["DELIBERATIVO"].label}
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item
                        name="checkConsultaFiscal"
                        colon={false}
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handlerCheckConsultaFiscal}
                        >
                          {CategoriasDirigente["FISCAL"].label}
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Space>
                </Form.Item>
              </Col>

              {/* </Card> */}
            </Row>

            <Row>
              <Col xs={24} sm={5}>
                <Form.Item label="CPF" name="nuCpf">
                  <Input
                    value={form.getFieldValue("nuCpf")}
                    onChange={(e) => maskFieldCpf(e.target.value)}
                    placeholder="Digitar o número do CPF"
                    maxLength={14}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Nome" name="nmPessoaFisica">
                  <Input placeholder="Digitar o nome" />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <>
                <Button
                  style={{ marginRight: "5px" }}
                  id="consultar"
                  type="primary"
                  value="default"
                  shape="round"
                  onClick={() => getMandatoDirigente()}
                >
                  Consultar
                </Button>
                <Button
                  id="limpar"
                  value="default"
                  shape="round"
                  onClick={() => limparConsulta()}
                >
                  Limpar
                </Button>
              </>
            </Row>
          </Form>
        </Card>

        <Card title={"Resultado da consulta - " + totalElements + " encontrados"} style={{ display: totalElements === 0 ? 'none' : 'inline' }}>
          <Table
            // className="overflowConsulta"
            dataSource={mandatoConselheiros}
            size={"small"}
            columns={columns}
            rowKey="idConselheiro"
            loading={loading}
            pagination={{
              // disabled: loading,
              // current: form.getFieldValue("pagina"),
              defaultPageSize: DEFAULT_PAGE_SIZE,
              pageSize: pageSize,
              total: totalElements,
              showSizeChanger: true,
              onShowSizeChange: handleShowSizeChange,
              onChange: handlePaginationChange,
              pageSizeOptions: PAGE_SIZE_OPTIONS,
              locale: { items_per_page: "Linhas por página" },
            }}
          />
        </Card>
      </>
    </Spin>
  );
};

export default Consultar;
